import { ControlledCheckbox } from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { addAccountSync } from 'RestAPIs/admin';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import { showSnackbar } from 'components/shared';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { useFormContext } from 'react-hook-form';
import { generalSchema } from '../utils';
import useSaveAtMultipleEndpoint from '../useSaveAtMultipleEndpoint';
import { isNil } from 'ramda';
import { generalFormData, TabProps } from '../types';

export const GeneralTab = ({ userAndPwdSettings }: TabProps) => {
  const { isLoading, mutateSSO, mutateNameCase, mutateNameSync } =
    useSaveAtMultipleEndpoint();

  const { t } = useTranslation('common', { keyPrefix: 'userAndPassword' });

  const onSubmit = (data: generalFormData) => {
    if (!isNil(data)) {
      mutateSSO({
        ...userAndPwdSettings.ssoSettings[0],
        active: data.single_sign_on
      });
      mutateNameSync({
        ...userAndPwdSettings.nameSync[0],
        active: data.account_synchronisation_email
      });
      mutateNameCase({
        ...userAndPwdSettings.nameCase[0],
        active: data.case_sensitive_login
      });
    }
  };

  const handleClick = () =>
    addAccountSync({})
      .then(() =>
        showSnackbar({ message: t('syncStarted'), severity: 'success' })
      )
      .catch(() => showErrorSnackbar(t('syncFailed')));

  return (
    <AdminSettingsFormWrapper
      handleSync={handleClick}
      isFetching={false}
      submitForm={onSubmit}
      data={{
        single_sign_on: userAndPwdSettings.ssoSettings[0]?.active,
        case_sensitive_login: userAndPwdSettings.nameCase[0]?.active,
        account_synchronisation_email: userAndPwdSettings.nameSync[0]?.active
      }}
      isLoading={isLoading}
      schema={generalSchema}
    >
      <FormFields />
    </AdminSettingsFormWrapper>
  );
};

const FormFields = () => {
  const { t } = useTranslation('common', { keyPrefix: 'userAndPassword' });
  const { control } = useFormContext();

  return (
    <>
      <ControlledCheckbox
        control={control}
        name="single_sign_on"
        label={t('activatedSSO')}
      />
      <ControlledCheckbox
        control={control}
        name="case_sensitive_login"
        label={t('activateCaseSensitive')}
      />
      <ControlledCheckbox
        control={control}
        name="account_synchronisation_email"
        label={t('activateEmailSync')}
      />
    </>
  );
};
